export * from '@primeuix/themes/aura/chip';
export { default } from '@primeuix/themes/aura/chip';
